import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { IAckHWMState } from "../../types/IAckHWMState";
import {
    CWR_ACK2_JOB_TYPE,
    HIGH_WATER_MARK_KEY,
    HIGH_WATER_MARK_TITLE,
} from "../../Consts";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { getLookupValues } from '../../../lookup/services/LookupHelpers';
import { SUBMITTER_LOOKUP } from "../../../lookup/Consts";
import DatePickerDataInput from "../../../repertoire/components/dateDataInput/DatePickerDataInput";

export interface ICWRACK2JobParametersProps {
    setManualJobParameters: (parameters: ITriggerManualJob) => void;
    cwrAckHWM: IAckHWMState[];
    lookups: ILookupDictionary;
}

interface ICWRACK2JobParametersState {
    hwm: any;
    selectedOpenSubmitters: any[];
    selectedIPIs: any[],
    submitters: any[];
}

export class CWRACK2JobParameters extends React.Component<
    ICWRACK2JobParametersProps,
    ICWRACK2JobParametersState
> {
    constructor(props: ICWRACK2JobParametersProps) {
        super(props);

        this.state = { 
            hwm: null,
            selectedOpenSubmitters: [],
            selectedIPIs: [],
            submitters: getLookupValues(SUBMITTER_LOOKUP, this.props.lookups),
        };

    }

    renderIPIOptions = () => {
        const { submitters } = this.state;
        const seen = {};

        const options = (submitters || []).map((s) => {
            const ipNameNumber = s.extraFields.IPNameNumber;
            seen[ipNameNumber] = (seen[ipNameNumber] || 0) + 1;

            return {
                data: s.extraFields.IPNameNumber,
                text: `${s.description} - ${s.extraFields.IPNameNumber}`,
                key: `${s.extraFields.IPNameNumber}-${seen[ipNameNumber]}`
            };

        });

            options.sort((a, b) => {
                const descA = a.text.split(" - ")[0] || "";
                const descB = b.text.split(" - ")[0] || "";
                const textCompare = descA.localeCompare(descB);
                if (textCompare !== 0) return textCompare;

                // secondary sort by number
                return Number(a.data) - Number(b.data);
            });

    options.unshift({ key: "All", text: "All", data: "*" });
    return options;
    
};


    changeHWM = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        if (!option) return;

        const { setManualJobParameters } = this.props;
        const { submitters, selectedOpenSubmitters, selectedIPIs } = this.state;

        const submitterOptions = this.renderIPIOptions();
        let selectSubmitterState = [...selectedOpenSubmitters];

        if (option.key === "All") {
            if (option.selected && selectSubmitterState.length != submitterOptions.length - 1) {
                selectSubmitterState = submitterOptions
                    .map(o => o.key.toString());
            } else {
                selectSubmitterState = [];
            }
        } else if (option.selected) {
            if (!selectSubmitterState.includes(option.key.toString())) {
                selectSubmitterState.push(option.key.toString());
            }
        } else {
            if(option.key != "All"){
                selectSubmitterState = selectSubmitterState.filter(
                    key => key != "All" && key !== option.key.toString()
                );
            } else {
                selectSubmitterState = selectSubmitterState.filter(
                    key => key !== option.key.toString()
                );
            }
        }

        const selectedOptions = submitterOptions.filter(
            o => o.key !== "All" && selectSubmitterState.includes(o.key.toString())
        );

        const allSelected = selectSubmitterState.includes("All");
        const ipis = allSelected
            ? ["All"]
            : [...new Set(selectedOptions.map(o => o.data.toString()))];
        this.setState({ selectedIPIs: ipis });

        const manualJobParameters: ITriggerManualJob = {
            jobType: CWR_ACK2_JOB_TYPE,
            jobParameters: JSON.stringify({ "IPINameNumbers": ipis, "HighWaterMark": null }),
        };
        setManualJobParameters(manualJobParameters);

        if (selectSubmitterState.length === 1) {
            const selected = submitterOptions.find(o => o.key.toString() === selectSubmitterState[0]);
            const ipi = selected?.data?.toString();
            const submitter = submitters.find(x => x.extraFields.IPNameNumber.toString() === ipi);
            const ackHWM = submitter ? submitter.extraFields.ACKHighWaterMark : null;
            this.setState({ hwm: ackHWM ? new Date(ackHWM) : null });
        }
        else {
            this.setState({ hwm: null });
        }
        this.setState(() => ({ selectedOpenSubmitters: selectSubmitterState }));
    };

    updateHWM = (value: string | boolean | Date, fieldName?: string, index?: number) => {

        const { setManualJobParameters } = this.props;
        const { selectedIPIs } = this.state;
        const manualJobParameters: ITriggerManualJob = {
            jobType: CWR_ACK2_JOB_TYPE,
            jobParameters: JSON.stringify({ "IPINameNumbers": selectedIPIs, "HighWaterMark": value }),
        };
        setManualJobParameters(manualJobParameters);
        this.setState({ hwm: value });
    }

    render() {
        const { hwm } = this.state;
        
        const onRenderPeriodDropdownTitle = (
            options: IDropdownOption[] | undefined
        ): JSX.Element => {
            const displayValue = options.filter(o => o.text !== 'All').map(o => o.text).join(", ");
            return (
                <div>
                    <span>{displayValue}</span>
                </div>
            );
        };

        return (
            <>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Submitter</label>
                    <Dropdown
                        selectedKeys={this.state.selectedOpenSubmitters}
                        options={this.renderIPIOptions()}
                        multiSelect={true}
                        onChange={this.changeHWM}
                        placeholder={""}
                        disabled={false}
                        required={true}
                        onRenderTitle={onRenderPeriodDropdownTitle}
                    />
                </div>
                
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DatePickerDataInput
                        label={HIGH_WATER_MARK_TITLE}
                        fieldName={HIGH_WATER_MARK_KEY}
                        changeData={this.updateHWM}
                        value={hwm}
                        readOnly={false}
                        isHidden={false}
                    />
                </div>
            </>
        );
    }
}
